import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../../config/config';
import { FiClipboard, FiUsers } from 'react-icons/fi';
import DashboardStats from './DashboardStats';
import DashboardQuickAccess from './DashboardQuickAccess';

/**
 * Dashboard para técnicos: estadísticas de tickets + accesos a
 * gestión de tickets y usuarios (sin proyectos ni ajustes, reservados a admin).
 */
const DashboardTecnico = ({ tokenInfo, onLinkClick }) => {
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [cargandoTotales, setCargandoTotales] = useState(true);
  const token = localStorage.getItem('AuthToken');

  useEffect(() => {
    const fetchTotales = async () => {
      setCargandoTotales(true);
      try {
        const [usuariosResp, ticketsResp] = await Promise.all([
          axios.get(`${BASE_URL}/todos-usuarios-conteo`),
          axios.get(`${BASE_URL}/tickets/total-conteo`, { headers: { Authorization: token } }),
        ]);
        setTotalUsuarios(usuariosResp.data.total || 0);
        setTotalTickets(ticketsResp.data.total || 0);
      } catch (err) {
        console.error('Error al obtener totales del dashboard:', err);
      } finally {
        setCargandoTotales(false);
      }
    };
    fetchTotales();
  }, [token]);

  const cards = [
    {
      to: '/dashboard/tickets',
      icon: FiClipboard,
      color: 'azul',
      title: 'Gestionar Tickets',
      description: 'Responde y administra tickets de tu departamento.',
      value: totalTickets,
      valueLabel: 'Incidencias abiertas',
    },
    {
      to: '/dashboard/usuarios',
      icon: FiUsers,
      color: 'verde',
      title: 'Gestionar Usuarios',
      description: 'Administra y verifica los usuarios de la plataforma.',
      value: totalUsuarios,
      valueLabel: 'Usuarios registrados',
    },
  ];

  return (
    <div className="dash-panel">
      <div className="dash-welcome">
        <h1>Bienvenido, {tokenInfo.nombre}</h1>
        <p>Revisa aquí tus tickets asignados y gestiona tus tareas.</p>
      </div>

      <div className="dash-section">
        <span className="dash-section-title">Estadísticas generales</span>
        <DashboardStats />
      </div>

      <div className="dash-section">
        <span className="dash-section-title">Accesos rápidos</span>
        {cargandoTotales ? (
          <div className="dash-tickets-loading">Cargando accesos rápidos...</div>
        ) : (
          <DashboardQuickAccess cards={cards} onLinkClick={onLinkClick} />
        )}
      </div>
    </div>
  );
};

export default DashboardTecnico;
